import React, { useEffect, useState } from 'react'
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import API from '../../services/api';
import { SlButton } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select'
import { localRegions } from '../../utils/constants';
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { Toast } from '../../shared/Toast'
import config from "../../config";
import Paginator from '../../shared/Paginator';
import { useDispatch, useSelector } from 'react-redux';
import '../creatives/CreativeList.scss';



function DiscountRanges() {
    const [data, setData] = useState([])
    const [loader, setLoader] = useState(false);
    const [regions, setRegions] = useState([]);
    const [addFlag, setAddFlag] = useState(false)
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const HeaderSearch = useSelector(state => state.Head.adssearch)
    const [initialRender, setInitialRender] = useState(true);



    const getdata = async(search ="", page = 0) =>{
        const result = await API({
            url: "/lineitems/getRanges",
            method: "post",
            responseType: "json",
            data: {search, page, limit: config.PER_PAGE}
        })
        if (result.code === 200) {
            setData(result.data.data);
            setTotalPages(Math.ceil(parseInt(result.data.total) / config.PER_PAGE));
          }

    }
    const handlePageClick = (event) => {
          setCurrentPage(event.selected);
          getdata(HeaderSearch, event.selected);
          
      };
      const Header = () => {
        if (!initialRender) {
            setCurrentPage(0);
            getdata(HeaderSearch, 0);
        }
      }
    const formik = useFormik({
        initialValues:{
            startRange: 0,
            endRange: 0,
            email: "",
            mobile: "",
            user_type: 0,
            headof: -2,
        },
        validationSchema:Yup.object({
            startRange: Yup.number().required("Required").min(0.1, "Start Range is Required").max(99),
            endRange: Yup.number().required("Required").min(Yup.ref('startRange'),"Should be greater than Start Range").max(100),
            email: Yup.string().email().required("Required"),
            mobile:  Yup.string()
            .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
            .min(10, "Mobile must be 10 digits")
            .max(10, "Mobile must be 10 digits")
            .required("Mobile Number is required"),
            user_type: Yup.number().min(1, "Required"),
            headof: Yup.number().required("Required").min(-1)
        }),
        onSubmit: async(values) =>{
            const addDiscount = await API({
                url : "lineitems/addRange",
                data: values,
                responseType:"json",
                method: "post",
            })
            if(addDiscount.code === 200 ){
                if(!addDiscount.data){
                    Toast("success",`${addDiscount.message}`)
                    getdata()
                    setAddFlag(false)
                }
                else
                {
                    if(Object.keys(addDiscount?.data).length){
                        Toast("error",`Already Exits ${addDiscount.data.email}`)
                    }
                }
            }
            else{
                Toast("error", addDiscount.data.message)
            }
        }
    })
    useEffect(()=> {
        getdata()
        getRegions()
        setInitialRender(false)
    },[])
    useEffect(()=>{
        if(+formik.values.user_type === 1 && regions.length === 0){
            getRegions()
        }
    },[formik.values.user_type])
    useEffect(() => {
        Header()
      }, [HeaderSearch])

    const getRegions = async() => {
        try {
            const regionsData = await API({
                url: "/user/sales_persons/getregionsofheader",
                method: "POST",
                responseType: "json",
                data: { user_type: 1},
            })
            if (regionsData?.data?.length) setRegions([{label: "Legal", value: -1},{label: "Others", value: 0},...regionsData.data]);
        } catch (error) {
            console.error("Error @ getRegions \n",error)
        }
    }

    const defaultValue = (options, value) => {
        return options ? options.filter((option) => option.value === value) : "";
      };
      function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }
    const updateActive = async(range_id, active) => {
        const updateActive = await API({
            url: "lineitems/updateActive",
            method: "post",
            responseType: "json",
            data: {range_id, active}
        })
        getdata()
    }
  return (
    <div>
        <div className="creativeListPage">
            <div className="cl-card">
                <header className="cl-header">
                    <div className="cl-title-block">
                        <h1 className="cl-title">Discount Ranges</h1>
                        <p className="cl-subtitle">Configure approval discount ranges by user type and region</p>
                    </div>
                    <div className="cl-toolbar cl-toolbar--inline">
                        <SlButton variant="primary" size="medium" onClick={() => { setAddFlag(true) }}>
                            <SlIcon library="lucide" name="plus" slot="prefix"></SlIcon>
                            Add Range
                        </SlButton>
                    </div>
                </header>

                <div className="cl-table-wrap">
                    <table className="cl-table">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Head OF</th>
                                <th>Start</th>
                                <th>End</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        {data?.length && !loader ? (
                            <tbody>
                                {data?.map((item, index) => {
                                    let regex = new RegExp(/\[([\d.]+),([\d.]+)\]/)
                                    let range = regex.exec(item.range)
                                    return (
                                        <tr key={item.campaign_id}>
                                            <td className="cl-name" data-label="Type">{+item.user_type === 1 ? "Editorial" : +item.user_type === 2 ? "Local" : "Leagal"}</td>
                                            <td data-label="Head OF">{+item.user_type === 3 ? "-" : +item.user_type === 1 ? defaultValue(regions, +item.headof)[0]?.label : defaultValue(localRegions, +item.headof)[0]?.label}</td>
                                            <td data-label="Start">{range[1]}</td>
                                            <td data-label="End">{range[2]}</td>
                                            <td data-label="Email">{item.email}</td>
                                            <td data-label="Mobile">{item.mobile}</td>
                                            <td data-label="Action">
                                                <span className="cl-switch">
                                                    <div className="form-check form-switch">
                                                        <input className="form-check-input" type="checkbox" role="switch" checked={item.active === 1} onChange={(e) => { updateActive(item.range_id, item.active) }} />
                                                    </div>
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        ) : !data?.length && !loader ? (
                            <NoDataFound colspan="7" />
                        ) : (
                            <TableLoader colspan="7" />
                        )}
                    </table>
                </div>
            </div>
            {totalPages > 1 && (
                <div className="cl-pagination">
                    <Paginator
                        pageCount={totalPages}
                        handlePageClick={handlePageClick}
                        forcePage={currentPage}
                    />
                </div>
            )}
        </div>
        <SlDrawer label="Add Range" open={addFlag} onSlRequestClose={handleRequestClose} onSlAfterHide={() => {setAddFlag(false);formik.resetForm()}} >


              <form onSubmit={formik.handleSubmit} className='contents'>
                  <fieldset>
                      <div className="mb-4">
                          <label htmlFor="" className="form-label font-medium">User Type</label>
                          < b className="text-red-600">*</ b>
                          <select
                              className="form-select"
                              aria-label="Default select example"
                              name="user_type"
                              placeholder='select'
                              value={formik.values.user_type}
                              onBlur={formik.handleBlur}
                              onChange={(e) => { formik.handleChange(e); if(+e.target.value === 3){formik.setFieldValue("headof",0)}}}
                          >   <option value="0">Select User Type</option>
                              <option value="1">Editorial</option>
                              <option value="2">Local</option>
                          </select>
                          {formik.errors.user_type && formik.touched.user_type ? <div className="text-red-600">{formik.errors.user_type}</div> : null}

                      </div>

                      <div className="mb-4">
                          <label htmlFor="" className="form-label font-medium">Email</label>
                          < b className="text-red-600">*</ b>
                          <input type="text"
                              className="form-control"
                              name="email"
                              placeholder='Enter Email'
                              value={formik.values.email}
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}

                          />
                          {formik.errors.email && formik.touched.email ? <div className="text-red-600">{formik.errors.email}</div> : null}

                      </div>

                      <div className="mb-4">

                          <label htmlFor="" className="form-label font-medium">Mobile</label>
                          < b className="text-red-600">*</ b>
                          <input
                              className="form-control"
                              name="mobile"
                              placeholder='Enter Mobile Number'
                              onBlur={formik.handleBlur}
                              value={formik.values.mobile}
                              onChange={formik.handleChange}
                          />
                          {formik.errors.mobile && (formik.touched.mobile) ? <div className="text-red-600">{formik.errors.mobile}</div> : null}

                      </div>
                      {+formik.values.user_type !== 3  ? <div className="row mb-4 align-items-end">
                          <div className="col">
                              <label htmlFor="" className="form-label font-medium">Head Of</label>
                              <div className="flex gap-3">
                                  <div className="flex-grow">
                                      <Select type="text"
                                          className=""
                                          name="headof"
                                          placeholder='Select'
                                          value={+formik.values.user_type === 1 ? defaultValue(regions, formik.values.headof) : +formik.values.user_type === 2 ? defaultValue(localRegions, formik.values.headof) : ""}
                                          onBlur={formik.handleBlur}
                                          onChange={selected => { formik.setFieldValue('headof', selected.value); }}
                                          options={[{ label: "Select", value: -2 }, ...+formik.values.user_type === 1 ? regions : +formik.values.user_type === 2 ? localRegions : []]}
                                      />
                                      {formik.errors.headof && formik.touched.headof ? <div className="text-red-600">{formik.errors.headof}</div> : null}
                                  </div>
                              </div>
                          </div>
                      </div> : null}
                      <div className="mb-4">

                          <label htmlFor="" className="form-label font-medium">Percentage Range</label>
                          < b className="text-red-600">*</ b>
                          <div className='d-flex align-items-center'>
                          <span>
                          <input
                              type='number'
                              className="form-control"
                              name="startRange"
                              placeholder='Enter Start'
                              onBlur={formik.handleBlur}
                              value={formik.values.startRange}
                              onChange={formik.handleChange}
                          />
                          {formik.errors.startRange && (formik.touched.startRange) ? <div className="text-red-600">{formik.errors.startRange}</div> : null}
                          </span>
                          <span className="ml-1 mt-5">
                        <b>%</b>
                        </span>
                          <span><b>-</b></span>
                          <span>
                          <input
                              type='number'
                              className="form-control ml-1"
                              name="endRange"
                              placeholder='Enter End'
                              onBlur={formik.handleBlur}
                              value={formik.values.endRange}
                              onChange={formik.handleChange}
                          />
                          {formik.errors.endRange && (formik.touched.endRange) ? <div className="text-red-600">{formik.errors.endRange}</div> : null}
                          </span>
                          <span className="ml-1 mt-5">
                        <b>%</b>
                        </span>
                          </div>

                      </div>
                      <div>
                          <SlButton type='submit' variant="primary" >Submit</SlButton>
                      </div>
                      
                  </fieldset>
              </form>

          </SlDrawer>
    </div>
  )
}

export default DiscountRanges
